import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export type ThemeMode = 'system' | 'light' | 'dark'

interface ThemeState {
  mode: ThemeMode
  setMode: (mode: ThemeMode) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      // Default to light. User can flip to dark / system from the profile.
      mode: 'light',
      setMode: (mode) => set({ mode }),
    }),
    {
      name: 'cmms-theme',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
